import { inject, Injectable } from '@angular/core';
import { ShowIfHttpError } from '@certemy/common';
import { BehaviorSubject, Observable } from 'rxjs';
import { HttpService } from 'services/http/http.service';
import {
  NotificationResponse,
  NotificationsObject,
} from 'features/profile-page/email-notifications-page/email-notifications.page.constants';
import {
  ActivatedRouteSnapshot,
  CanActivateFn,
  CanMatchFn,
  Router,
  RouterStateSnapshot,
  UrlSegment
} from '@angular/router';

@Injectable()
export class OrganizationNotificationsService {
  constructor(private http: HttpService) { }
  isAdminNotificationActive$: BehaviorSubject<boolean> = new BehaviorSubject(false);

  @ShowIfHttpError('Cannot receive notification settings.')
  getNotificationsSettings(): Observable<NotificationResponse> {
    return this.http.get('/notification-settings/organization');
  }

  @ShowIfHttpError('An error occurred while updating notifications.')
  updateNotificationsSettings(changedNotification: NotificationsObject): Observable<any> {
    return this.http.put('/notification-settings/organization', changedNotification);
  }

  @ShowIfHttpError('Cannot apply to all users.')
  applyToAllUsers(): Observable<any> {
    return this.http.post('/notification-settings/reset-organization-profile', {}, { withoutErrorRedirect: true });
  }

  @ShowIfHttpError('An error occurred while overriding notifications settings.')
  restoreNotificationsSettings(
    profileId: number,
  ): Observable<any> {
    return this.http.post(`/notification-settings/profile/${profileId}/reset`, {});
  }
}

export const matchRedirectSettingsGuard: CanMatchFn = (
  route: ActivatedRouteSnapshot,
  segments: UrlSegment[],
): boolean => {
  const router = inject(Router);
  const isPathIncluded = ['admin-settings', 'general-settings']
    .some(path => router.routerState.snapshot.url.includes(path));

  if (!segments.length && isPathIncluded) {
    router.navigate([router.routerState.snapshot.url]);
    return false;
  }

  return true;
}
